import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import Showcase from 'src/components/showcase';
import FeatureSectionUsecases from 'src/components/features/feature-section-usecases';
import Quote from 'src/components/quote';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

import {
  metaData,
  productHeader,
  features,
  interactiveData,
  showcase,
  featureSection,
  quote,
  footerExtension,
} from 'src/store/en-eu/products/transactions';

import { ProductPageTemplate } from 'src/templates';

const InteractiveData = dynamic(
  () => {
    return import('src/components/Surfaces/InteractiveData/InteractiveData');
  },
  {
    ssr: false,
  },
);

const EUProductTransactions = ({ locale = Locales.EN_EU }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeader} />
      <Features {...features} />
      <InteractiveData {...interactiveData} />
      <Showcase {...showcase} />
      <FeatureSectionUsecases {...featureSection} />
      <Quote {...quote} />
      <FooterExtension {...footerExtension} />
    </ProductPageTemplate>
  );
};

export default EUProductTransactions;
